// Persists the pending GoCardless mandate-signing context across the full-page redirect to the GoCardless
// hosted authorisation page (TD-16969 FE). The backend redirect URI is a single static value
// (ConfigurationPayments.goCardlessMandateRedirectUri), so it does NOT carry the mandate id back — we keep it
// here so the mandate-return page can read it to call `complete` and know where to send the member afterwards.
// Uses localStorage (not sessionStorage) so it reliably survives the external round-trip inside the mobile app
// WebView. It is short-lived: cleared as soon as the flow completes, is cancelled, or has no pending mandate.
export interface GoCardlessMandateFlowContext {
    idMandate: string;
    returnUrl: string;
}

export class GoCardlessMandateFlowStorage {
    private static readonly KEY = 'gocardless-mandate-flow';

    static save(context: GoCardlessMandateFlowContext): void {
        localStorage.setItem(this.KEY, JSON.stringify(context));
    }

    static read(): GoCardlessMandateFlowContext | null {
        const raw = localStorage.getItem(this.KEY);
        if (!raw) {
            return null;
        }

        try {
            const context = JSON.parse(raw) as GoCardlessMandateFlowContext;
            // Validate the shape: storage is same-origin writable, and `returnUrl` is later passed to the router,
            // so only accept an internal (leading-slash) path and a non-empty mandate id.
            if (!context?.idMandate || typeof context.returnUrl !== 'string' || !context.returnUrl.startsWith('/')) {
                return null;
            }

            return context;
        } catch {
            return null;
        }
    }

    static clear(): void {
        localStorage.removeItem(this.KEY);
    }
}
